import { keepPreviousData, useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import { IBanner } from "types/banner";

export const getBannerList = async () => {
  try {
    const result = await FETCHER.get<IBanner[]>(`/banners`);
    return result.data;
  } catch (e) {
    console.log(e);
  }
};
export const useGetBannerList = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["getBannerList"],
    queryFn: () => getBannerList(),
    placeholderData: keepPreviousData,
  });
  return {
    bannerList: data,
    isLoading,
  };
};
